import { Component, ViewEncapsulation, OnInit, OnDestroy, HostListener } from '@angular/core';
import { SessionTimeoutService } from './shared/services/session-timeout.service';
import { GoogleAnalyticsService } from './shared/services/google-analytics.service';
import { AppConfig } from './app-config';
import { environment } from '../environments/environment';
import { shouldUseAppConfigForEnvironment } from './shared/helpers/environments';
import { ViewportScroller } from '@angular/common';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss'],
  encapsulation: ViewEncapsulation.None
})
export class AppComponent implements OnInit, OnDestroy {
  title = 'arvest-bpp';

  public displayMobileDropdown = false;
  public inMaintenanceMode = false;
  public processingLogout = false;

  /**
   * @param sessionTimeOutService is here to be sure it initializes when the app loads
   * @param googleAnalyticsServie is here to be sure it initializes when the app loads
   */
  constructor(
    private sessionTimeOutService: SessionTimeoutService,
    private googleAnalyticsServie: GoogleAnalyticsService,
    private viewportScroller: ViewportScroller,
    private appConfig: AppConfig) {

    let code;

    if (shouldUseAppConfigForEnvironment(this.appConfig && this.appConfig.config && this.appConfig.config.environment)) {
      code = appConfig.config.googleTagCode;
      this.inMaintenanceMode = this.appConfig.config.maintenance;
    } else {
      code = environment.googleTagCode;
      this.inMaintenanceMode = environment.maintenance;
    }

    const script: HTMLScriptElement = document.createElement('script');
    script.async = true;
    script.text = `(function(w,d,s,l,i){w[l]=w[l]||[];w[l].push({'gtm.start':
    new Date().getTime(),event:'gtm.js'});var f=d.getElementsByTagName(s)[0],
    j=d.createElement(s),dl=l!='dataLayer'?'&l='+l:'';j.async=true;j.src=
    'https://www.googletagmanager.com/gtm.js?id='+i+dl;f.parentNode.insertBefore(j,f);
    })(window,document,'script','dataLayer','${code}');`;
    document.head.prepend(script);
  }

  ngOnInit() {}

  ngOnDestroy() {}

  @HostListener('window:resize', ['$event'])
  onResize(event: any) {
    console.log('Resizing');
  }

  public toggleDropdown() {
    this.displayMobileDropdown = !this.displayMobileDropdown;
    this.toggleBodyScroll();
  }

  public hideDropdown() {
    this.displayMobileDropdown = false;
    this.allowBodyToScroll();
  }

  public checkForMobileBrowser() {
  }

  public onClick(elementId: string): void {
    document.getElementById(elementId).focus();
    this.viewportScroller.scrollToAnchor(elementId);
  }

  private toggleBodyScroll() {
    this.displayMobileDropdown ? this.dontLetBodyToScroll() : this.allowBodyToScroll();
  }

  private dontLetBodyToScroll() {
    document.body.classList.add('not-scrollable');
  }

  private allowBodyToScroll() {
    document.body.classList.remove('not-scrollable');
  }

  handleLogout() {
    this.processingLogout = true;
  }
}
